import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import greenShadow from '../../assets/images/shop_donate_item_shadow.png';
import moneyImage from '../../assets/images/shop_donate_money.png';
import moneyImageShadow from '../../assets/images/shop_donate_money_shadow.png';

const StyledGreenShadow = styled.div`
	position: absolute;
	width: 1300px;
	height: 1300px;
	left: -650px;
	bottom: -650px;
	z-index: 1;
	background-image: url(${greenShadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

const StyledMoneyImage = styled.div`
	position: absolute;
	width: 340px;
	height: 255px;
	top: 50%;
	right: 20px;
	transform: translateY(-50%);
	z-index: 2;
	background-image: url(${moneyImage});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
	transition:
		width 0.3s ease,
		height 0.3s ease;
`;

const StyledMoneyImageShadow = styled.div`
	position: absolute;
	bottom: -5px;
	right: -90px;
	z-index: 2;
	rotate: 10deg;
	width: 600px;
	height: 180px;
	background-image: url(${moneyImageShadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
	transition: bottom 0.3s ease;
`;

const StyledShadow = styled.div`
	position: absolute;
	width: 100%;
	height: 180px;
	bottom: 1px;
	left: 0;
	z-index: 3;
	background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
	opacity: 0.5;
	transition:
		opacity 0.3s ease,
		height 0.3s ease;
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	${Text} {
		font-size: 16px;
		font-weight: 700;
	}
`;

const StyledBottomContainer = styled.div`
	position: absolute;
	bottom: 15px;
	left: 19px;
	z-index: 4;
	display: flex;
	flex-direction: column;

	& > ${Text} {
		font-weight: 500;
		font-size: 16px;
		color: #ffffff;
	}

	button {
		padding: 0 10px;
		border-radius: 5px;
		margin-top: 16px;
	}
`;

const StyledMoreBlock = styled.div`
	align-self: flex-start;
	width: fit-content;
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 8px;
	margin-top: 0;
	height: 0;
	overflow: hidden;
	transition:
		height 0.3s ease,
		margin-top 0.3s ease;

	${Text} {
		font-weight: 700;
		font-size: 14px;
		color: #ffffff;
		opacity: 0.5;
		transition: opacity 0.3s ease;
	}

	img {
		width: 10px;
		height: 10px;
		user-select: none;
		pointer-events: none;
		opacity: 0.5;
		transition: opacity 0.3s ease;
	}

	&:hover ${Text}, &:hover img {
		opacity: 1;
	}
`;

const StyledContainer = styled.div`
	position: relative;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 5px;
	padding: 19px 19px 16px 19px;
	height: 339px;
	overflow: hidden;
	cursor: pointer;

	&:hover {
		${StyledShadow} {
			opacity: 1;
			height: 240px;
		}

		${StyledMoneyImage} {
			width: 380px;
			height: 285px;
		}

		${StyledMoneyImageShadow} {
			bottom: -20px;
		}

		${StyledMoreBlock} {
			height: 12px;
			margin-top: 16px;
		}
	}
`;

const StyledPriceContainer = styled.div`
	position: relative;
	display: flex;
	gap: 10px;
	justify-content: flex-start;
	align-items: center;
	margin: 16px 0 0;
	transition: margin 0.3s ease;
`;

const StyledPrice = styled.div<{ $isDonate?: boolean }>`
	display: flex;
	gap: 10px;
	align-items: center;

	img {
		transition: filter 0.3s ease;
	}

	${Text} {
		font-weight: 700;
		font-size: 20px;
		color: ${(props) => (props.$isDonate ? '#FFBB00' : '#ffffff')};
		padding-top: 1px;
		transition: color 0.3s ease;
	}
`;

const StyledOldPrice = styled.div`
	position: relative;
	display: flex;
	gap: 6px;
	padding: 0 5px;
	margin-top: 2px;

	img {
		width: 12px;
		height: 12px;
		margin-top: 2px;
		opacity: 0.25;
		user-select: none;
		pointer-events: none;
		filter: grayscale(100%);
	}

	${Text} {
		font-weight: 500;
		font-size: 16px;
		color: #ffffff;
		opacity: 0.25;
		transition: color 0.3s ease;
	}

	.line {
		position: absolute;
		top: 7px;
		left: 0;
		width: 100%;
		height: 1px;
		background-color: #ff3737;
	}
`;

const StyledBackNumbers = styled(Text)`
	font-size: 110px;
	line-height: 110px;
	font-weight: 700;
	color: #1f8034;
	opacity: 0.05;
	position: absolute;
	text-align: center;
	top: 0;
	left: 50%;
	transform: translateX(-50%);
	z-index: 1;
`;

const StyledDiscountContainer = styled.div`
	padding: 3px 5px;
	background-color: #ff3d3d;
	border-radius: 6px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #ffffff;
	}
`;

const StyledTag = styled.div<{
	$bgColorNormal: string;
	$textColorNormal: string;
}>`
	padding: 3px 5px;
	background: ${(props) => props.$bgColorNormal};
	border-radius: 6px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: ${(props) => props.$textColorNormal};
	}
`;

const StyledDiscountTimerContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
	height: 20px;
	padding: 0 5px;
	background-color: #ff3d3d;
	border-radius: 6px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #ffffff;
	}

	.divider {
		width: 1px;
		height: 20px;
		background-color: rgba(0, 0, 0, 0.1);
	}
`;

const StyledTagsContainer = styled.div`
	position: absolute;
	top: 19px;
	left: 19px;
	display: flex;
	gap: 10px;
	flex-wrap: wrap;
	justify-content: flex-start;
`;

export {
	StyledBackNumbers,
	StyledBottomContainer,
	StyledButtonContent,
	StyledContainer,
	StyledDiscountContainer,
	StyledDiscountTimerContainer,
	StyledGreenShadow,
	StyledMoneyImage,
	StyledMoneyImageShadow,
	StyledMoreBlock,
	StyledOldPrice,
	StyledPrice,
	StyledPriceContainer,
	StyledShadow,
	StyledTag,
	StyledTagsContainer,
};
